import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Master from "../views/Master.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  ////// ホーム ///////
  // ホーム
  {
    path: "/",
    name: "Home",
    redirect: "/medical/transmission" // 医療請求管理にリダイレクト
  },

  ////// 医療請求管理 ///////
  // 医療請求管理
  {
    path: "/medical/merge",
    name: "MedicalMerge",
    component: () =>
      import(
        /* webpackChunkName: "medical_merge" */ "../views/MedicalMerge.vue"
      )
  },
  {
    path: "/medical/edit/:id",
    name: "MedicalEdit",
    component: () =>
      import(/* webpackChunkName: "medical_edit" */ "../views/MedicalEdit.vue")
  },
  {
    path: "/medical/summarytable",
    name: "SummaryTable",
    component: () =>
      import(
        /* webpackChunkName: "summary_table" */ "../views/SummaryTable.vue"
      )
  },

  ////// 医療請求伝送 ///////
  {
    path: "/medical/transmission",
    name: "MedicalTransmission",
    component: () =>
      import(
        /* webpackChunkName: "medical_transmission" */ "../views/MedicalTransmission.vue"
      )
  },
  {
    path: "/medical/transmission/edit/:id",
    name: "MedicalTransmissionEdit",
    component: () =>
      import(
        /* webpackChunkName: "medical_transmission_edit" */ "../views/MedicalTransmissionEdit.vue"
      )
  },

  ////// 医療伝送返戻 ///////
  {
    path: "/medical/return",
    name: "MedicalReturn",
    component: () =>
      import(
        /* webpackChunkName: "medical_return" */ "../views/MedicalReturn.vue"
      )
  },

  ////// 介護請求管理 ///////
  // 介護請求管理
  {
    path: "/care/merge",
    name: "CareMerge",
    component: () =>
      import(/* webpackChunkName: "care_merge" */ "../views/CareMerge.vue")
  },
  {
    path: "/care/edit/:id",
    name: "CareEdit",
    component: () =>
      import(/* webpackChunkName: "care_edit" */ "../views/CareEdit.vue")
  },

  ////// 介護請求伝送 ///////
  {
    path: "/care/transmission",
    name: "TransmissionInlineFrame",
    component: () =>
      import(
        /* webpackChunkName: "care_transmission" */ "../views/TransmissionInlineFrame.vue"
      )
  },

  ////// 利用者請求管理 ///////
  // 利用者請求管理
  {
    path: "/userinvoice",
    name: "UserInvoice",
    component: () =>
      import(/* webpackChunkName: "user_invoice" */ "../views/UserInvoice.vue")
  },
  {
    path: "/userinvoice/edit/:id",
    name: "UserInvoiceEdit",
    component: () =>
      import(
        /* webpackChunkName: "user_invoice_edit" */ "../views/UserInvoiceEdit.vue"
      )
  },

  ////// レセプトダッシュボード ///////
  // 請求一覧
  {
    path: "/billinglist",
    name: "BillingList",
    component: () =>
      import(/* webpackChunkName: "billinglist" */ "../views/BillingList.vue")
  },
  // 請求一覧（詳細）
  {
    path: "/billinglistdetails",
    name: "BillingListDetails",
    component: () =>
      import(
        /* webpackChunkName: "billinglistdetails" */ "../views/BillingListDetails.vue"
      )
  },
  // 請求一覧（詳細/処理済月）
  {
    path: "/billinglistdetailsprintedat",
    name: "BillingListDetailsFilterPrintedDate",
    component: () =>
      import(
        /* webpackChunkName: "billinglistdetailsprintedat" */ "../views/BillingListDetailsFilterPrintedDate.vue"
      )
  },
  // 口座振替データ管理
  {
    path: "/account_transfer",
    name: "AccountTransferManage",
    component: () =>
      import(
        /* webpackChunkName: "account_transfer" */ "../views/AccountTransferManage.vue"
      )
  },

  ////// 入金管理 ///////
  // 入金管理
  {
    path: "/payment_manage",
    name: "PaymentManage",
    component: () =>
      import(
        /* webpackChunkName: "payment_manage" */ "../views/PaymentManage.vue"
      )
  },

  ////// 未処理データ一覧 ///////
  // 未処理データ一覧
  {
    path: "/all_no_output",
    name: "AllNoOutput",
    component: () =>
      import(/* webpackChunkName: "all_no_output" */ "../views/AllNoOutput.vue")
  },

  ////// 設定 ///////
  // 設定
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue")
  },
  {
    path: "/commingsoon",
    name: "Commingsoon",
    component: () =>
      import(/* webpackChunkName: "commingsoon" */ "../views/Commingsoon.vue")
  },

  ////// オペレーションログ ///////
  {
    path: "/operation_log",
    name: "OperationLog",
    component: () =>
      import(
        /* webpackChunkName: "operation_log" */ "../views/OperationLog.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
